export default __webpack_public_path__ + "static/media/no_show_alarm.2c9d545c.mp3";